(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-editorial-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root = document) => {
    const heroes = root.matches?.('[data-mm-reveal-hero]') ? [root] : root.querySelectorAll('[data-mm-reveal-hero]');
    heroes.forEach((hero) => {
      if (hero.dataset.mmReady) return;
      hero.dataset.mmReady = 'true';
      const visual = hero.querySelector('[data-mm-reveal-visual]');
      if (!visual || !hero.querySelector('.mm-reveal-hero__scene--aged img')) return;
      const mobile = matchMedia('(max-width: 749px)');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      visual.addEventListener('pointermove', (event) => {
        if (mobile.matches || reduced.matches) return;
        const frame = visual.getBoundingClientRect();
        visual.style.setProperty('--mm-x', (((event.clientX - frame.left) / frame.width) * 100) + '%');
        visual.style.setProperty('--mm-y', (((event.clientY - frame.top) / frame.height) * 100) + '%');
        hero.dataset.mmActive = 'true';
      });
      visual.addEventListener('pointerleave', () => { delete hero.dataset.mmActive; });
      visual.addEventListener('focus', () => { if (!mobile.matches) hero.dataset.mmActive = 'true'; });
      visual.addEventListener('blur', () => { delete hero.dataset.mmActive; delete hero.dataset.mmAll; });
      visual.addEventListener('keydown', (event) => {
        if (event.key !== ' ' && event.key !== 'Enter') return;
        event.preventDefault();
        if (hero.dataset.mmAll) delete hero.dataset.mmAll;
        else hero.dataset.mmAll = 'true';
      });
      let pending = false;
      const update = () => {
        pending = false;
        if (!mobile.matches || reduced.matches) return;
        const travel = Math.max(1, hero.offsetHeight - innerHeight);
        const progress = Math.min(1, Math.max(0, -hero.getBoundingClientRect().top / travel));
        hero.style.setProperty('--mm-progress', progress.toFixed(3));
      };
      const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(update); } };
      addEventListener('scroll', schedule, { passive: true });
      addEventListener('resize', schedule, { passive: true });
      schedule();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-footer-wordmark"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('mm-footer-wordmark')) {
    customElements.define('mm-footer-wordmark', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const options = { passive: true, signal: this.controller.signal };
        const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
        const reset = () => {
          this.style.removeProperty('--mm-x');
          this.style.removeProperty('--mm-y');
        };
        window.addEventListener('pointermove', event => {
          if (reduced.matches) return;
          const rect = this.getBoundingClientRect();
          if (rect.bottom < 0 || rect.top > window.innerHeight) return;
          const x = Math.max(-1, Math.min(1, (event.clientX - rect.left) / rect.width * 2 - 1));
          const y = Math.max(-1, Math.min(1, (event.clientY - rect.top) / rect.height * 2 - 1));
          this.style.setProperty('--mm-x', (-x * 8).toFixed(2) + 'px');
          this.style.setProperty('--mm-y', (-y * 6).toFixed(2) + 'px');
        }, options);
        this.addEventListener('pointerdown', event => {
          if (reduced.matches || event.pointerType === 'mouse') return;
          const rect = this.getBoundingClientRect();
          this.style.setProperty('--mm-x', ((.5 - (event.clientX - rect.left) / rect.width) * 16).toFixed(2) + 'px');
          this.style.setProperty('--mm-y', '-6px');
        }, options);
        this.addEventListener('pointerleave', event => {
          if (event.pointerType === 'mouse') reset();
        }, options);
        this.addEventListener('pointerup', event => {
          if (event.pointerType !== 'mouse') {
            clearTimeout(this.resetTimer);
            this.resetTimer = setTimeout(reset, 1200);
          }
        }, options);
        this.addEventListener('pointercancel', reset, options);
        reduced.addEventListener('change', reset, options);
      }
      disconnectedCallback() { this.controller?.abort(); clearTimeout(this.resetTimer); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mm-patina-reveal-hero"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root = document) => {
    const heroes = root.matches?.('[data-mm-patina-hero]') ? [root] : root.querySelectorAll('[data-mm-patina-hero]');
    heroes.forEach(hero => {
      if (hero.dataset.mmReady) return;
      hero.dataset.mmReady = 'true';
      const visual = hero.querySelector('[data-mm-patina-visual]');
      const mobile = matchMedia('(max-width: 749px)');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const pullback = parseFloat(getComputedStyle(hero).getPropertyValue('--mm-pullback')) || 0;
      const plantShift = parseFloat(getComputedStyle(hero).getPropertyValue('--mm-plant-shift')) || 0;
      const setProgress = progress => {
        visual.style.setProperty('--mm-progress', progress.toFixed(3));
        visual.style.setProperty('--mm-camera-scale', (1 + (1 - progress) * pullback).toFixed(3));
        visual.style.setProperty('--mm-plant-left', (-progress * plantShift).toFixed(1) + 'px');
        visual.style.setProperty('--mm-plant-right', (progress * plantShift).toFixed(1) + 'px');
      };
      setProgress(0);
      visual.addEventListener('pointermove', event => {
        if (mobile.matches || reduced.matches || event.pointerType === 'touch') return;
        const box = visual.getBoundingClientRect();
        visual.style.setProperty('--mm-x', ((event.clientX - box.left) / box.width * 100) + '%');
        visual.style.setProperty('--mm-y', ((event.clientY - box.top) / box.height * 100) + '%');
        hero.dataset.mmActive = 'true';
        setProgress(1);
      });
      visual.addEventListener('pointerleave', () => {
        delete hero.dataset.mmActive;
        if (!hero.dataset.mmAll) setProgress(0);
      });
      visual.addEventListener('keydown', event => {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        if (hero.dataset.mmAll) { delete hero.dataset.mmAll; setProgress(0); }
        else { hero.dataset.mmAll = 'true'; setProgress(1); }
      });
      let pending = false;
      const update = () => {
        pending = false;
        if (!mobile.matches || reduced.matches) return;
        const travel = Math.max(1, hero.offsetHeight - visual.offsetHeight);
        const progress = Math.min(1, Math.max(0, -hero.getBoundingClientRect().top / travel));
        setProgress(progress);
      };
      const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(update); } };
      addEventListener('scroll', schedule, { passive: true });
      addEventListener('resize', schedule, { passive: true });
      schedule();
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
